/* Climbing game — Send Theory. Each [data-climb-game] element on the page becomes its own game. */
(function(){
  'use strict';
  var ROWS = 19; // 18 holds (including the start hold) + the top-out pad
  var PENDING_KEY = 'climb-game-pending';
  var BEST_KEY = 'climb-best';
  var SEEN_KEY = 'climb-game-popup-seen';
  var HASH = '#climb-game';

  // ---------- seven-segment timer digits ----------
  var SEGS={0:'abcdef',1:'bc',2:'abged',3:'abgcd',4:'fgbc',5:'afgcd',6:'afgedc',7:'abc',8:'abcdefg',9:'abcdfg'};
  function hs(y){return '3,'+y+' 5,'+(y-2)+' 15,'+(y-2)+' 17,'+y+' 15,'+(y+2)+' 5,'+(y+2)}
  function vs(x,a,b){return x+','+a+' '+(x+2)+','+(a+2)+' '+(x+2)+','+(b-2)+' '+x+','+b+' '+(x-2)+','+(b-2)+' '+(x-2)+','+(a+2)}
  var GEO={a:hs(2),g:hs(17),d:hs(32),f:vs(2,3,16),b:vs(18,3,16),e:vs(2,18,31),c:vs(18,18,31)};
  function sevenSeg(str,on,off){
    var x=0,body='';
    for(var i=0;i<str.length;i++){var ch=str[i];
      if(ch==='.'){body+='<rect x="'+x+'" y="29" width="4" height="4" fill="'+on+'"/>';x+=7;continue}
      var lit=SEGS[ch]||'';
      for(var k in GEO)body+='<polygon transform="translate('+x+' 0)" points="'+GEO[k]+'" fill="'+(lit.indexOf(k)>-1?on:off)+'"/>';
      x+=24;
    }
    return '<svg viewBox="-2 -1 '+(x+2)+' 36" aria-hidden="true"><g transform="skewX(-7) translate(4 0)">'+body+'</g></svg>';
  }
  function fmt(ms){var t=Math.min(ms/1000,99.99);return (t<10?'0':'')+t.toFixed(2)}
  function store(fn){try{return fn(window.sessionStorage)}catch(e){return null}}
  function local(fn){try{return fn(window.localStorage)}catch(e){return null}}

  function init(root){
    if(root.__climbGame)return; root.__climbGame=true;
    var q=function(n){return root.querySelector('[data-cg="'+n+'"]')};
    var stage=q('stage'),cv=q('canvas'),ctx=cv.getContext('2d');
    var popup=root.closest('[data-cg-popup]'),lastFocus=null;
    var designMode=!!(window.Shopify&&window.Shopify.designMode);
    var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
    var imgs=[root.getAttribute('data-pose-1'),root.getAttribute('data-pose-2')].map(function(src){var i=new Image();i.src=src;return i});
    var baseTags=(root.dataset.tags||'').trim();
    var cs=getComputedStyle(root);
    var C={wall:cs.getPropertyValue('--cg-wall').trim()||'#D3D4D7',tnut:cs.getPropertyValue('--cg-tnut').trim()||'#77787C',seam:cs.getPropertyValue('--cg-seam').trim()||'#A5A6AA'};
    var W=0,H=0,dpr=1,rowH=100,ch=120,visible=true,lastT='';
    var wall,S;

    function resize(){
      var r=stage.getBoundingClientRect();W=r.width;H=r.height;dpr=Math.min(window.devicePixelRatio||1,3);
      cv.width=Math.round(W*dpr);cv.height=Math.round(H*dpr);ctx.setTransform(dpr,0,0,dpr,0,0);
      ch=Math.min(H*0.2,W*0.3,170);rowH=ch;
      if(S&&!S.moving)S.x=laneX(S.lane);
    }
    function laneX(l){return W*(1+2*l)/6}

    function speedHold(){return{rot:Math.random()*Math.PI*2,long:Math.floor(Math.random()*4),j:[0,1,2,3].map(function(){return .9+Math.random()*.2})}}
    function smoothPath(pts,x,y,R){
      var n=pts.length,m=function(i){var a=pts[i%n],b=pts[(i+1)%n];return[(a[0]+b[0])/2,(a[1]+b[1])/2]};
      ctx.beginPath();var s0=m(n-1);ctx.moveTo(x+s0[0]*R,y+s0[1]*R);
      for(var i=0;i<n;i++){var p=pts[i],c=m(i);ctx.quadraticCurveTo(x+p[0]*R,y+p[1]*R,x+c[0]*R,y+c[1]*R)}
      ctx.closePath();
    }
    function drawHold(h,x,y,R){
      var pts=[];for(var i=0;i<4;i++){var a=h.rot+i*Math.PI/2,L=(i===h.long?1.28:1)*h.j[i];
        pts.push([Math.cos(a-.2)*L*.95,Math.sin(a-.2)*L*.95],[Math.cos(a+.12)*L,Math.sin(a+.12)*L],[Math.cos(a+Math.PI/4)*.34,Math.sin(a+Math.PI/4)*.34])}
      smoothPath(pts,x,y,R);ctx.fillStyle='#000';ctx.fill();
      ctx.beginPath();ctx.arc(x,y,Math.max(2.5,R*.11),0,7);ctx.fillStyle='#fff';ctx.fill();
    }
    function drawPad(x,y,s,hit){
      ctx.fillStyle=hit?'#000':'#fff';ctx.strokeStyle='#000';ctx.lineWidth=4;ctx.beginPath();
      if(ctx.roundRect)ctx.roundRect(x-s/2,y-s/2,s,s,6);else ctx.rect(x-s/2,y-s/2,s,s);
      ctx.fill();ctx.stroke();
      ctx.beginPath();ctx.arc(x,y,s*.18,0,7);ctx.fillStyle=hit?'#fff':'#000';ctx.fill();
    }

    // Rules: next hold is same lane or adjacent; never 3 in a row in one lane;
    // last hold + top-out pad always in the middle. Retries until a wall passes every rule.
    function build(){
      for(;;){
        wall=[{lane:1,hold:speedHold()}];var ok=true;
        for(var r=1;r<ROWS;r++){
          var prev=wall[r-1].lane,prev2=r>1?wall[r-2].lane:-1;
          var opts=[0,1,2].filter(function(l){return Math.abs(l-prev)<=1&&!(l===prev&&l===prev2)});
          if(r>=ROWS-2)opts=opts.filter(function(l){return l===1});
          else if(r===ROWS-3)opts=opts.filter(function(l){return l!==1});
          if(!opts.length){ok=false;break}
          var w=opts.map(function(l){return l===prev?1:1.6}),t=Math.random()*w.reduce(function(a,b){return a+b}),k=0;
          while(t>w[k]){t-=w[k];k++}
          wall.push({lane:opts[k],hold:speedHold()});
        }
        if(ok)return;
      }
    }
    function reset(){
      build();
      S={row:0,lane:1,x:laneX(1),y:0,fromX:0,fromY:0,toX:0,toY:0,t0:0,moving:false,pose:0,flip:1,cam:0,shakeT:-1e9,
         started:false,done:false,start:0,elapsed:0,taps:0,hits:0,queued:null};
      q('timer').classList.remove('is-stopped');lastT='';updateHud();
    }
    function worldY(r){return -r*rowH}
    function updateHud(){
      q('prog').textContent=S.row+' / '+(ROWS-1);
      var t=fmt(S.elapsed);
      if(t!==lastT){lastT=t;q('time').innerHTML=sevenSeg(t,'#fff','rgba(255,255,255,.13)');q('timer').setAttribute('aria-label',t+' seconds')}
    }
    function isOpen(){return !popup||!popup.hidden}
    function playing(){return isOpen()&&q('start').hidden&&q('done').hidden}
    function accuracy(){return S.taps?Math.round(S.hits/S.taps*100):100}

    function tap(target){
      if(S.done||!playing())return;
      if(S.moving){S.queued=target;return}
      var next=wall[S.row+1];if(!next)return;
      if(!S.started){S.started=true;S.start=performance.now()}
      S.taps++;
      if(target===next.lane){
        var dir=target-S.lane;S.hits++;
        S.moving=true;S.fromX=S.x;S.fromY=S.y;S.lane=target;S.row++;S.toX=laneX(target);S.toY=worldY(S.row);S.t0=performance.now();
        S.pose^=1;if(dir!==0)S.flip=dir<0?-1:1;
        return true;
      }
      S.shakeT=performance.now();
      if(navigator.vibrate){try{navigator.vibrate(40)}catch(e){}}
      return false;
    }

    function showResults(ms,acc,misses){
      q('acc').textContent=acc+'%';q('misses').textContent=misses;
      q('final').innerHTML=sevenSeg(fmt(ms),'#fff','rgba(255,255,255,.12)');
      q('final').setAttribute('aria-label',(Math.round(ms/10)/100).toFixed(2)+' seconds');
    }
    function finish(){
      S.done=true;S.elapsed=performance.now()-S.start;updateHud();
      q('timer').classList.add('is-stopped');
      showResults(S.elapsed,accuracy(),S.taps-S.hits);
      var t=Math.round(S.elapsed/10)/100,best=parseFloat(local(function(l){return l.getItem(BEST_KEY)}))||null,msg;
      if(!best||t<best){local(function(l){l.setItem(BEST_KEY,t)});msg=best?'New best. Previous was '+best.toFixed(2)+'s':'Your first top-out'}
      else msg='Best: '+best.toFixed(2)+'s';
      q('best').textContent=msg;
      showEnd('actions');
      setTimeout(function(){q('done').hidden=false;q('again').focus({preventScroll:true})},reduce?0:450);
    }

    function showEnd(view){
      q('actions').hidden=view!=='actions';
      if(q('formview'))q('formview').hidden=view!=='form';
      q('saved').hidden=view!=='saved';
    }

    function ease(t){return 1-Math.pow(1-t,3)}
    function frame(now){
      requestAnimationFrame(frame);
      if(!W||!visible)return;
      if(S.moving){
        var d=reduce?60:170,t=Math.min(1,(now-S.t0)/d),e=ease(t);
        S.x=S.fromX+(S.toX-S.fromX)*e;S.y=S.fromY+(S.toY-S.fromY)*e-Math.sin(t*Math.PI)*rowH*.08;
        if(t>=1){S.moving=false;S.x=S.toX;S.y=S.toY;
          if(S.row===ROWS-1)finish();
          else if(S.queued!==null){var qd=S.queued;S.queued=null;tap(qd)}}
      }else S.x=laneX(S.lane);
      if(S.started&&!S.done){S.elapsed=now-S.start;updateHud()}
      S.cam+=(S.y-S.cam)*(reduce?1:.18);
      var anchor=H*0.66,sy=function(wy){return anchor+(wy-S.cam)};

      // wall: square panels, bolt grid, seams between lanes
      ctx.fillStyle=C.wall;ctx.fillRect(0,0,W,H);
      var ps=W/3,poff=((anchor-S.cam)%ps+ps)%ps,g=ps/5,x,y;
      ctx.fillStyle=C.tnut;
      for(y=poff-ps+g/2;y<H+ps;y+=g)for(x=g/2;x<W;x+=g){ctx.beginPath();ctx.arc(x,y,1.4,0,7);ctx.fill()}
      ctx.strokeStyle=C.seam;ctx.lineWidth=1;ctx.beginPath();
      for(y=poff-ps;y<H+ps;y+=ps){ctx.moveTo(0,y);ctx.lineTo(W,y)}
      ctx.moveTo(ps,0);ctx.lineTo(ps,H);ctx.moveTo(ps*2,0);ctx.lineTo(ps*2,H);ctx.stroke();

      // top edge of the wall and the floor
      var topY=sy(worldY(ROWS-1))-ch*.42-rowH*.55;
      if(topY>-10){ctx.fillStyle='#fff';ctx.fillRect(0,0,W,topY);ctx.fillStyle='#000';ctx.fillRect(0,topY-6,W,6)}
      var baseY=sy(0)+ch*.9;if(baseY<H+20){ctx.fillStyle='#000';ctx.fillRect(0,baseY,W,4)}

      // holds + top-out pad
      var R=Math.min(rowH*.2,W*.075);
      for(var r=0;r<ROWS;r++){
        var hy=sy(worldY(r))-ch*.42;if(hy<-R*2||hy>H+R*2)continue;
        if(r===ROWS-1)drawPad(laneX(wall[r].lane),hy,R*2.3,S.done);
        else drawHold(wall[r].hold,laneX(wall[r].lane),hy,R*1.25);
      }

      // character
      var img=imgs[S.pose];
      if(img.complete&&img.naturalWidth){
        var cw=ch*img.naturalWidth/img.naturalHeight,dx=0,st=now-S.shakeT;
        if(st<260&&!reduce)dx=Math.sin(st/260*Math.PI*6)*(1-st/260)*ch*.08;
        ctx.save();ctx.translate(S.x+dx,sy(S.y));ctx.scale(S.flip,1);ctx.drawImage(img,-cw/2,-ch/2,cw,ch);ctx.restore();
      }
    }

    // ---------- input ----------
    Array.prototype.forEach.call(root.querySelectorAll('.cg-btn'),function(b){
      var lane=+b.dataset.lane;
      b.addEventListener('pointerdown',function(e){e.preventDefault();b.classList.add('is-down');
        if(tap(lane)===false){b.classList.add('is-nope');setTimeout(function(){b.classList.remove('is-nope')},220)}});
      ['pointerup','pointerleave','pointercancel'].forEach(function(t){b.addEventListener(t,function(){b.classList.remove('is-down')})});
      b.addEventListener('click',function(e){if(e.detail===0)tap(lane)}); // keyboard activation
    });
    document.addEventListener('keydown',function(e){
      if(!playing()||S.done||!visible)return;
      var k={ArrowLeft:0,a:0,A:0,'1':0,ArrowUp:1,ArrowDown:1,s:1,S:1,'2':1,ArrowRight:2,d:2,D:2,'3':2}[e.key];
      var tag=(e.target&&e.target.tagName)||'';
      if(k!==undefined&&tag!=='INPUT'&&tag!=='TEXTAREA'){e.preventDefault();tap(k)}
    });
    // Only block page scrolling on the wall while a climb is in progress
    stage.addEventListener('touchmove',function(e){if(playing()&&!S.done)e.preventDefault()},{passive:false});

    q('go').addEventListener('click',function(){q('start').hidden=true});
    function playAgain(){reset();showEnd('actions');q('done').hidden=true}
    q('again').addEventListener('click',playAgain);q('again2').addEventListener('click',playAgain);

    // ---------- sign-up (Shopify customer / newsletter form) ----------
    var form=q('formview')&&q('formview').closest('form');
    if(q('signup'))q('signup').addEventListener('click',function(){showEnd('form');q('err').hidden=true;var se=q('servererr');if(se)se.hidden=true;q('email').focus()});
    if(q('back'))q('back').addEventListener('click',function(){showEnd('actions');q('signup').focus()});
    if(form){
      form.addEventListener('submit',function(e){
        var em=q('email').value.trim();
        if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)){e.preventDefault();q('err').hidden=false;q('email').focus();return}
        var secs=(S.elapsed/1000).toFixed(2),acc=accuracy();
        var extra=['climb-time-'+secs,'climb-accuracy-'+acc];
        q('tagsfield').value=(baseTags?baseTags+',':'')+extra.join(',');
        q('submit').disabled=true;q('submit').textContent='Saving…';
        // Remember the result so it can be shown again after Shopify reloads the page
        store(function(s){s.setItem(PENDING_KEY,JSON.stringify({ms:S.elapsed,acc:acc,misses:S.taps-S.hits,best:q('best').textContent}))});
        // Let the browser submit the form normally (Shopify handles spam checks and redirects back here)
      });
    }

    // After Shopify redirects back: show "saved" or the error, with the same result
    function restoreAfterPost(){
      var pending=store(function(s){return JSON.parse(s.getItem(PENDING_KEY)||'null')});
      if(!pending)return false;
      var posted=!!q('posted'),se=q('servererr');
      if(!posted&&!se)return false;
      store(function(s){s.removeItem(PENDING_KEY)});
      S.done=true;S.elapsed=pending.ms;S.row=ROWS-1;S.lane=1;S.y=worldY(ROWS-1);S.cam=S.y;updateHud();
      showResults(pending.ms,pending.acc,pending.misses);q('best').textContent=pending.best||'';
      q('start').hidden=true;q('done').hidden=false;
      if(posted){
        q('savedmsg').textContent='Score saved: '+(pending.ms/1000).toFixed(2)+'s, '+pending.acc+'% accuracy';
        showEnd('saved');
      }else{showEnd('form');}
      if(!popup)root.scrollIntoView({block:'center'});
      return true;
    }

    // ---------- pop-up ----------
    function markSeen(){
      if(!popup||designMode)return;
      var mode=popup.dataset.frequency;
      if(mode==='session')store(function(s){s.setItem(SEEN_KEY,'1')});
      else local(function(l){l.setItem(SEEN_KEY,'1')});
    }
    function seen(){
      var mode=popup.dataset.frequency;
      return mode==='session'?!!store(function(s){return s.getItem(SEEN_KEY)}):!!local(function(l){return l.getItem(SEEN_KEY)});
    }
    function focusables(){return Array.prototype.filter.call(popup.querySelectorAll('button,a[href],input'),function(el){return !el.disabled&&el.offsetParent!==null})}
    function openPopup(){
      if(!popup||!popup.hidden)return;
      lastFocus=document.activeElement;
      popup.hidden=false;document.documentElement.classList.add('cg-lock');
      visible=true;resize();markSeen();
      var f=q('start').hidden?focusables()[0]:q('go');
      if(f)setTimeout(function(){f.focus({preventScroll:true})},30);
    }
    function closePopup(){
      if(!popup||popup.hidden)return;
      popup.hidden=true;document.documentElement.classList.remove('cg-lock');
      // back to a fresh start screen for next time
      reset();showEnd('actions');q('done').hidden=true;q('start').hidden=false;
      if(lastFocus&&lastFocus.focus)lastFocus.focus({preventScroll:true});
    }
    if(popup){
      Array.prototype.forEach.call(popup.querySelectorAll('[data-cg-dismiss]'),function(el){el.addEventListener('click',closePopup)});
      document.addEventListener('keydown',function(e){
        if(popup.hidden)return;
        if(e.key==='Escape'){e.preventDefault();closePopup();return}
        if(e.key==='Tab'){var f=focusables();if(!f.length)return;var first=f[0],last=f[f.length-1];
          if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
          else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}
      });
      popup.addEventListener('touchmove',function(e){if(!e.target.closest('.cg-card'))e.preventDefault()},{passive:false});
      // Any link to #climb-game (menu item, button) opens the game again
      document.addEventListener('click',function(e){
        var a=e.target.closest&&e.target.closest('a[href]');
        if(a&&a.getAttribute('href').slice(-HASH.length)===HASH){e.preventDefault();openPopup()}
      });
      // Theme editor: open while the section is selected, close when it isn't
      document.addEventListener('shopify:section:select',function(e){if(e.target.contains(root))openPopup()});
      document.addEventListener('shopify:section:deselect',function(e){if(e.target.contains(root))closePopup()});
    }

    // ---------- boot ----------
    if('ResizeObserver' in window)new ResizeObserver(resize).observe(stage);else window.addEventListener('resize',resize);
    if('IntersectionObserver' in window)new IntersectionObserver(function(en){visible=en[0].isIntersecting}).observe(root);
    resize();reset();
    var restored=restoreAfterPost();
    if(popup){
      if(restored||location.hash===HASH)openPopup();
      else if(!designMode&&!seen()){
        var delay=(parseFloat(popup.dataset.delay)||0)*1000;
        setTimeout(openPopup,delay);
      }
    }
    requestAnimationFrame(frame);
  }

  function initAll(scope){Array.prototype.forEach.call((scope||document).querySelectorAll('[data-climb-game]'),init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll()});else initAll();
  // Theme editor: re-init when the section is added or its settings change
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();
